<template>
  <div class="afl-cats">
    <div class="my-filter-container-desktop afl">
      <!-- uzi ekran: naslov koji otvara/zatvara filter -->
      <div class="btn-expanded" @click="clickShow">
        <div class="filter-text text-uppercase text-muted">
          Filteri
        </div>
        <div class="filter-img-awesome text-right">
          <i id="down-awesome" class="esei icon-chevron-down d-block text-muted"></i>
          <i id="up-awesome" class="esei icon-chevron-up d-none text-muted"></i>
        </div>
      </div>

      <div id="nav-container" class="drop-container p-2">
        <section class="afl-sec afl-sec-first">
          <h5 class="afl-sec-title">Kategorije</h5>

          <div class="afl-search">
            <i class="esei icon-magnifying-glass-solid" aria-hidden="true"></i>
            <input v-model="categoryQuery"
                   type="search"
                   class="afl-input"
                   placeholder="Pronađi kategoriju…"
                   aria-label="Pronađi kategoriju"
                   autocomplete="off" />
          </div>

          <!-- pravi linkovi (vide ih i pretrazivaci) -->
          <ul class="afl-list">
            <li>
              <NuxtLink class="afl-item"
                        :class="{ on: selectAll(route.fullPath) }"
                        :to="routePath({ name: 'kalendar-dogadjaja-dogadjaji-year-month-page', params: { year: getYear(), month: getMonth(), page: 1 } })">
                <span>Sve kategorije</span>
              </NuxtLink>
            </li>

            <li v-for="category in visibleCategories" :key="category.id">
              <NuxtLink class="afl-item"
                        :class="{ on: selectBG($srbTolat.srbTolat(category.name), route.params) }"
                        :to="routePath({ name: 'kalendar-dogadjaja-event-kategorija-year-month-page', params: { event: $srbTolat.srbTolat(category.name), year: getYearCheck(route.params.year), month: getMonthCheck(route.params.month), page: 1 } })"
                        @click="clickShow()">
                <span>{{ category.name }}</span>
              </NuxtLink>
            </li>

            <li v-if="!visibleCategories.length" class="afl-empty">{{ categoryQuery ? `Nema kategorije za „${categoryQuery}“.` : 'Nema kategorija.' }}</li>
          </ul>
        </section>
      </div>
    </div>
  </div>
</template>

<script setup>
import { normalizeText } from '~/composables/useListFilter'

  const route = useRoute();

  const dayjs = useDayjs()

  const routePath = useRoutePath()

const { $srbTolat } = useNuxtApp()


const props = defineProps({
    categories: Array
})

// pretraga kategorija u listi (lokalno, bez kvacica)
const categoryQuery = ref('')

const visibleCategories = computed(() => {
  const list = props.categories ?? []
  const query = normalizeText(categoryQuery.value)

  return query ? list.filter((category) => normalizeText(category.name).includes(query)) : list
})
 
const clickShow = () => {
    let nav = document.getElementById('nav-container');
      let aweUp = document.getElementById('up-awesome');
      let aweDown = document.getElementById('down-awesome');
      if(nav.classList.contains('show-container')){
         nav.classList.remove('show-container');
          aweDown.classList.remove('d-none')
          aweDown.classList.add('d-block')
          aweUp.classList.remove('d-block')
          aweUp.classList.add('d-none')
         
      } 
      else{
          nav.classList.add('show-container');
          aweDown.classList.remove('d-block')
          aweDown.classList.add('d-none')
          aweUp.classList.remove('d-none')
          aweUp.classList.add('d-block')
         
      } 
}
const resizeExpanded = () => {
    let nav = document.getElementById('nav-container');
       let aweUp = document.getElementById('up-awesome');
       let aweDown = document.getElementById('down-awesome');
       let width = window.innerWidth;
       if(width >= 990){
        if(aweDown.classList.contains('d-none')){
           aweDown.classList.remove('d-none')
           aweDown.classList.add('d-block')
        }
          if(aweUp.classList.contains('d-block')){
             aweUp.classList.remove('d-block')
             aweUp.classList.add('d-none')
          }
          nav.classList.remove('show-container')
       }
}

const getMonthCheck = (month) => {

    return month != undefined ? month : dayjs().format('MMMM').toLowerCase()
}

const getYearCheck = (year) => {

    return  year != undefined ? year : dayjs().year()
}
 
const selectAll = (item) => {

return  item.includes('dogadjaji') ? true : false;
}
const selectBG = (item, select) => {

  

return  select.event && select.event == item ? true : false;
}
const getYear = () => {

return  dayjs().year()
}
const getMonth = () => {

return  dayjs().format('MMMM').toLowerCase()
}

</script>

<style>

</style>
